/**
 * @description Gestion des inputs de type submit
 */

(() => {
	// la classe suivant est celle générée par le module search api spellcheck
	// Ajout d'un data-style sur les inputs de type submit
	// Dans form.js, la fonction webformsubmt permettra d'ajouter une div parent à ces inputs afin de pouvoir leur appliquer des pseudo elements (réutilisable pour les spe)

	const dataStyle = (selector) => {
		const inputs = document.querySelectorAll(selector);

		inputs.forEach((el) => {
			el.setAttribute('data-style', 'yes');
		});
	};

	// dataStyle('.webform-button--submit');
	const setSubmitStyle = () => {
		// SI changement à impaxter égalmeent dans
		const submits = document.querySelectorAll('[data-style="yes"]') || null;
		if (submits) {
			submits.forEach((submit) => {
				if (
					!submit.parentNode.classList.contains('btn-primary-submit')
				) {
					const wrapper = document.createElement('div');
					wrapper.classList.add('btn-primary-submit');
					submit.parentNode.insertBefore(wrapper, submit);
					wrapper.appendChild(submit);
				}
			});
		}
	};

	// GO après chargement 🚀
	window.addEventListener('load', function () {
		dataStyle(
			'.not-front input.submit:not(#edit-submit-main-search-engine):not(#edit-reset--2):not(#edit-submit-main-search-engine--2)'
		);
		setSubmitStyle();
	});
})();
